export type MedalTier = "gold" | "silver" | "bronze";

const MEDAL_TIERS: readonly MedalTier[] = ["gold", "silver", "bronze"];

export function assignMedalTiers(
  entries: ReadonlyArray<{ playerId: string; score: number }>,
): Map<string, MedalTier> {
  const result = new Map<string, MedalTier>();
  let tierIndex = 0;
  let currentScore: number | undefined;

  for (const entry of entries) {
    if (currentScore === undefined) {
      currentScore = entry.score;
    } else if (entry.score !== currentScore) {
      tierIndex += 1;
      if (tierIndex >= MEDAL_TIERS.length) {
        break;
      }
      currentScore = entry.score;
    }
    result.set(entry.playerId, MEDAL_TIERS[tierIndex]!);
  }

  return result;
}
